@if (showHeading) {
  <h2 class="nordic-blue-900-text text-icon-primary" [ngClass]="headingClasses">
    {{ titleTranslationKey | finLocalization }}
  </h2>
}
@if (unpaidServices && showUnpaidNotification()) {
  <fcom-notification
    class="ms-small-t"
    [iconName]="SvgLibraryIcon.SHOPPING_CART"
    [layout]="NotificationLayout.BLOCK"
    [theme]="NotificationTheme.WARNING"
    data-testid="unpaid-item-notification"
    [title]="'MMB.includedProducts.unpaidAncillaries.notificationTitle' | finLocalization"
  >
    {{ 'MMB.includedProducts.unpaidAncillaries.notificationText' | finLocalization }}
  </fcom-notification>
}
@if (headerContents$ | async; as contents) {
  <div
    class="mr-small-t white-bg surface-primary rounded-large pr-small"
    [class.border]="!isNewBrand()"
    [class.elevation-level-1]="isNewBrand()"
    data-testid="included-products-header-contents"
  >
    @for (item of contents; let first = $first; track $index) {
      <div [class.mr-small-t]="!first">
        <p>
          {{ item }}
        </p>
      </div>
    }
  </div>
}
<div
  class="bound-products mr-small-b"
  [class.pr-xsmall-t]="!isNewBrand()"
  [class.mr-xsmall-t]="isNewBrand()"
  [class.elevation-level-1]="isNewBrand()"
  [class.rounded-large]="isNewBrand()"
>
  <fcom-tabs
    [theme]="TabTheme.CLASSIC"
    [layoutType]="TabLayoutType.STRETCH"
    [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
    [nextButtonAriaLabel]="'carousel.next' | finLocalization"
    [tabStyleOverrideClasses]="'pr-small'"
  >
    @for (boundWithServices of servicesForBounds; let boundIndex = $index; track boundIndex) {
      <fcom-tab
        [title]="
          booking.locations[boundWithServices.departure.locationCode]?.cityName +
          ' - ' +
          booking.locations[boundWithServices.arrival.locationCode]?.cityName
        "
      >
        <div
          class="white-bg surface-primary rounded-bottom-large"
          [class.border-bottom]="!isNewBrand()"
          [class.border-left]="!isNewBrand()"
          [class.border-right]="!isNewBrand()"
        >
          @if (boundWithServices.services.length === 0) {
            <div class="pr-small">
              <fcom-notification>{{ 'MMB.includedProducts.noServicesTitle' | finLocalization }}</fcom-notification>
            </div>
          }
          <ng-container>
            @for (
              service of boundWithServices.services;
              let isFirstService = $first;
              let serviceIndex = $index;
              track serviceIndex
            ) {
              <div class="pr-xxsmall-b" [ngClass]="{ 'border-top': !isFirstService }">
                <fin-included-product-item
                  [attr.data-testid]="'ancillary-category-' + service.category"
                  [category]="service.category"
                  [buttonTranslationKey]="'MMB.includedProducts.' + service.category + '.title'"
                  [additionalTitle]="
                    showAdditionalTitle
                      ? ('purchase.review.ancillarySelection'
                        | finLocalization
                          : {
                              amount: service.bounds[0]?.quantity,
                              price: service.bounds[0]?.totalPrice | finPrice,
                            })
                      : ''
                  "
                  [passengers]="selectedPassengers || booking.passengers"
                  [bound]="boundWithServices"
                  [service]="service"
                  [expandOpen]="service.upsell?.expand || expandOpen"
                  [isShortHaulFlight]="isShortHaulFlight"
                  [displaySeatReassignMessage]="
                    displaySeatReassignMessage && isFirstService && service.category === Category.SEAT
                  "
                  [showPendingServicesInTitles]="showPendingServicesInTitles"
                  [showUnpaidTag]="showUnpaidNotification()"
                  [enableQuotaTag]="enableQuotaTag()"
                  [addSelectedItemsToQuota]="addSelectedItemsToQuota()"
                >
                  @if (!service.upsell?.enabled) {
                    <fin-dapi-included-service
                      [service]="service"
                      [products$]="products$"
                      [showAsPending]="showAsPending"
                      [cartOrOrder$]="booking | finToObservable"
                      [passengers$]="booking.passengers | finToObservable"
                      [showUpsellPerPax]="showUpsell"
                      [includeSeatActionButtons]="includeSeatActionButtons"
                      [isCarrierConnect]="isCarrierConnect"
                      [includeAssignAtAirportStatus]="includeAssignAtAirportStatus"
                      [showNonAYSeats]="showNonAYSeats"
                      [serviceModifyProgress]="serviceModifyProgress()"
                      [groupServicesByBound]="groupServicesByBound"
                      (selectProduct)="onSelectProduct($event, boundWithServices.id)"
                      (continuePurchase)="onContinuePurchase()"
                      (removeProduct)="onRemoveProduct($event, boundWithServices.id)"
                      (viewSeatmap)="viewSeatmap.emit()"
                      [mode]="mode"
                    />
                  }
                  @if (showUpsell && service.upsell?.enabled) {
                    <fin-upsell-card
                      [attr.data-testid]="'category-upsell-' + service.category"
                      [boundWithServices]="boundWithServices"
                      [service]="service"
                      (upsellClicked)="
                        onSelectProduct(
                          { category: service.category, fragmentId: boundWithServices.id },
                          boundWithServices.id
                        )
                      "
                    />
                  }

                  @if (showInformationModal) {
                    <fin-information-modal
                      [category]="service.category"
                      [upsell]="(upsellInModal$ | async)?.[boundWithServices.id]?.[service.category] ?? false"
                      (upsellClicked)="
                        onSelectProduct(
                          { category: service.category, fragmentId: boundWithServices.id },
                          boundWithServices.id
                        )
                      "
                    />
                  }
                  @if (service.upsell?.isShowMoreBtn && service.upsell?.updatingService === false) {
                    <div class="border-top ms-xsmall-t nordic-blue-100-border border-primary flex flex--row-reverse">
                      @if (service.category !== Category.SPECIAL_NEED) {
                        <fcom-button
                          class="block pr-xxsmall-t align-right"
                          (click)="
                            onSelectProduct(
                              { category: service.category, fragmentId: boundWithServices.id },
                              boundWithServices.id
                            )
                          "
                          [icon]="{
                            name: SvgLibraryIcon.PLUS,
                            position: IconPosition.RIGHT,
                          }"
                          [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
                          [size]="ButtonSize.MEDIUM"
                          [mode]="ButtonMode.FILL_MOBILE"
                          [text]="'actions.addMore' | finLocalization"
                        />
                      }
                      @if (service.category === Category.SPECIAL_NEED) {
                        <fcom-button
                          class="block pr-xxsmall-t align-right"
                          [href]="'MMB.links.specialAssistance.url' | finLocalization"
                          [icon]="{
                            name: SvgLibraryIcon.EXTERNAL_TAB,
                            position: IconPosition.RIGHT,
                          }"
                          [openInNewTab]="true"
                          [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                          [size]="ButtonSize.MEDIUM"
                          [mode]="ButtonMode.FILL_MOBILE"
                          [text]="'actions.assistance' | finLocalization"
                        />
                      }
                    </div>
                  }
                  @if (showModifyButtons.includes(service.category) && mode !== AllowedActionsMode.CART) {
                    <fcom-button
                      class="block pr-small-t align-right flex--self-end"
                      (clickBtn)="
                        onSelectProduct(
                          { category: service.category, fragmentId: boundWithServices.id },
                          boundWithServices.id
                        )
                      "
                      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
                      [mode]="ButtonMode.FILL_MOBILE"
                      [text]="'actions.modify' | finLocalization"
                    />
                  }
                </fin-included-product-item>
              </div>
            }
          </ng-container>

          @if (showTickets) {
            <div class="pr-small-b" [class.border-top]="servicesToShow.length > 0">
              <fin-included-product-item
                data-testid="category-tickets"
                category="tickets"
                buttonTranslationKey="MMB.includedProducts.tickets.title"
                additionalTitle=""
              >
                <fin-included-tickets
                  [locations]="booking.locations"
                  [bound]="boundWithServices"
                  [useCabinClass]="useCabinClass"
                />
              </fin-included-product-item>
            </div>
          }
        </div>
      </fcom-tab>
    }
  </fcom-tabs>
</div>
